import React from 'react';
import styled from 'styled-components';

import header from './img/header.png';
import textImg from './img/main-txt.png';
import vodVideo from './vod/main-vod.mp4';
import vodImg2 from './img/vod-img2.jpg';
import vodImg3 from './img/vod-img3.jpg';
import vodImg4 from './img/vod-img4.jpg';
import footerImg from './img/footer.jpg';
import pagenationImg from './img/pagenation.png';

function Video() {
  return (
    <StyledSubContainer>
      <div className="inner">
        <div className="vod-wrap">
          <img src={header} alt="" className="m-header" />
          <div className="txt-area">
            <img src={textImg} alt="" className="m-txt" />
            <img src={pagenationImg} alt="" className="m-pagenation" />
          </div>
          <video
            autoPlay
            loop
            muted
            playsInline
            className="video"
            width="100%"
            height="100%"
          >
            <source src={vodVideo} type="video/mp4" />
            <track
              default
              kind="captions"
              srcLang="en"
              src="https://mis-prod-koce-esg-cdn-blob-ep.azureedge.net/web/video/c61d0d9a30e1476bb4525b9f64bbd730.vtt"
            />
          </video>
        </div>
        <img src={vodImg2} alt="" />
        <img src={vodImg3} alt="" />
        <img src={vodImg4} alt="" />
        <img src={footerImg} alt="" />
      </div>
    </StyledSubContainer>
  );
}

const StyledSubContainer = styled.div`
  .inner {
    max-width: 1920px;
    margin: 0 auto;
    .vod-wrap {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-image: linear-gradient(
          rgba(48, 92, 212, 0.5),
          rgba(48, 92, 212, 0)
        );
      }
      .m-header {
        position: absolute;
        top: 4rem;
      }
      .txt-area {
        position: absolute;
        left: 50%;
        max-width: 1432px;
        margin: 0 auto;
        width: 100vw;
        height: 100vh;
        transform: translateX(-50%);
        .m-txt {
          position: absolute;
          top: 40rem;
        }
      }
      .m-pagenation {
        position: absolute;
        top: 40%;
        right: -9rem;
      }
    }
  }
`;

export default Video;
